<template>
  <div class="row" v-if="isLoading">
    <div class="col-md-12 text-center">
      <div class="spinner-border mt-3" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";

@Component({})
class Loading extends Vue {
  @Prop({ default: null })
  isLoading!: boolean;
}
export default Loading;
</script>
